const IconSizesEnum = {
  L: 'L' as 'L',
  M: 'M' as 'M',
  S: 'S' as 'S',
  XS: 'XS' as 'XS',
};
type IconSizesEnum = (typeof IconSizesEnum)[keyof typeof IconSizesEnum];
export { IconSizesEnum };
